import angular from 'angular'
import template from './template.html'

export class NominasNominaBancosDetalladoComponent {
  constructor(NominasNominaBancosDetallado) {
    this.NominasNominaBancosDetallado = NominasNominaBancosDetallado
    this.idEmpresa = undefined
    this.idNomina = undefined
    this.legacy = undefined
    this.data = undefined
  }

  $onInit() {
    this.NominasNominaBancosDetallado.grid(this.idEmpresa, this.idNomina)
      .then((response) => (this.data = response))
  }
}

angular.module('nominas.nomina')
  .component('nominasNominaBancosDetallado', {
    controller: NominasNominaBancosDetalladoComponent,
    template: template,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      legacy: '<',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/detallado/component.js